import { __rest } from "tslib";
import * as React from 'react';
import { DropdownSeparator } from '../Dropdown/DropdownSeparator';
export const ApplicationLauncherSeparator = (_a) => {
    var { 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(DropdownSeparator, Object.assign({}, props));
};
ApplicationLauncherSeparator.displayName = 'ApplicationLauncherSeparator';
//# sourceMappingURL=ApplicationLauncherSeparator.js.map